import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Image from '../../components/ContentfulImage';
import Markdown from '../../components/Markdown';
import plus from './plus-button.svg';
import plusBlack from './plus-button-black.svg';
import Placeholder from '../../components/Placeholder';

import {
  Pillar,
  Actions,
  Overlay,
  OverlayContent,
  Details,
  MarkdownStyle,
  ButtonContainer,
  CloseButton,
  Shadow,
} from './BrandPillar.style';

class BrandPillar extends React.Component {
  state = {
    open: false,
  };

  close = () => {
    this.setState({ open: false });
  };

  open = () => {
    this.setState({ open: true });
  };

  render = () => {
    const { open } = this.state;
    const { pillar, screenSize } = this.props;

    if (pillar.key) {
      return (
        <Pillar>
          <Placeholder w="100%" pb="100%" />
        </Pillar>
      );
    }

    return (
      <Pillar>
        <Image src={pillar.previewImage} options={{ w: '100%' }} />
        <Actions onClick={this.open}>
          {pillar.name}
          <img src={plus} alt="plus" />
        </Actions>

        {open && (
          <Overlay>
            <OverlayContent>
              <Image
                src={screenSize > 0 ? pillar.image : pillar.previewImage}
                options={{ objectFit: 'cover', size: 600, w: '600px' }}
              />
              <Details>
                <Markdown Component={MarkdownStyle} src={pillar.content} />
              </Details>
              <ButtonContainer onClick={this.close}>
                <CloseButton src={plusBlack} alt="close" />
              </ButtonContainer>
            </OverlayContent>
            <Shadow />
          </Overlay>
        )}
      </Pillar>
    );
  };
}

BrandPillar.propTypes = {
  pillar: PropTypes.shape().isRequired,
  screenSize: PropTypes.number.isRequired,
};

const mapState = state => ({
  screenSize: state.screenSize,
});

export default connect(mapState)(BrandPillar);



// WEBPACK FOOTER //
// ./src/pages/AboutPage/BrandPillar.js